import styled from "styled-components";
import { spacing } from "../../styles/styles.constants";

export const BroadcastPortal = styled.div`
	display: flex;
	justify-content: space-around;
	flex: 1;
	min-height: 0;
	gap: ${spacing.margin};
	padding: ${spacing.margin};
`;

export const SideColumn = styled.div`
	width: 25%;
	min-height: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: ${spacing.margin};
`;

export const CentralColumn = styled.div`
	width: 50%;
	min-height: 0;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	gap: ${spacing.margin};
`;

export const CentralUpper = styled.div`
	display: flex;
	justify-content: space-around;
	min-height: 0;
	flex: 1;
	gap: ${spacing.margin};
`;

export const CentralLower = styled.div`
	width: 100%;
	min-height: 0;
	height: 45%;
	display: flex;
	flex-direction: column;
`;
